import axios from "axios";

export const GET_TUTOR_LIST    = "GET_TUTOR_LIST";
export const GET_TUTOR_DETAIL  = "GET_TUTOR_DETAIL";
export const PUT_TUTOR_EDIT    = "PUT_TUTOR_EDIT";
export const POST_TUTOR_CREATE = "POST_TUTOR_CREATE";
export const DELETE_TUTOR      = "DELETE_TUTOR";

export const getTutorList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Tutor/ObtieneTodosLosTutor")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_TUTOR_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_TUTOR_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getTutorDetail = (id) => {

    return (dispatch) => {
        axios
            .get(
                "/api/Tutor/ObtieneTutorPorId?id=" +id
            )
            .then(function (response) {
                //console.log(response.data);

                dispatch({
                    type: GET_TUTOR_DETAIL,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: GET_TUTOR_DETAIL,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
}; //END DETAIL

export const putTutorUpdate = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/Tutor/" + id,data
                )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_TUTOR_EDIT,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_TUTOR_EDIT,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const postTutorCreate = (data) => {

    return (dispatch) => {
        axios
        .post(
            "/api/Tutor",data
        )
        .then(function (response) {
            //console.log(response);
        
            dispatch({
                type: POST_TUTOR_CREATE,
                payload: {
                    data: response.data,
                    errorMessage: false,
                },
            });
        })
        .catch(function (error) {
            dispatch({
                type: POST_TUTOR_CREATE,
                payload: {
                    data: false,
                    errorMessage: error.message,
                },
            });
        });
    };
  
};

export const deleteTutor = (data, id) => {

    return (dispatch) => {

        //console.log("ACTION deleteTutor");

        axios
            .put(
                "/api/Tutor/BorrarTutor/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: DELETE_TUTOR,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: DELETE_TUTOR,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
    
};